import { ERROR_TYPE } from 'constants/error';

class HookError extends Error {
  public errorContext;
  constructor(errorMsg: string, errorContext?: object) {
    super(`${ERROR_TYPE.HOOK}: ${errorMsg}`);
    this.errorContext = errorContext;
  }
  render() {
    return Error;
  }
}

export default HookError;
